import React from 'react';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import CircularProgress from 'material-ui/Progress/CircularProgress';
import Session from '../calendar/components/Session';
import EmptyState from '../common/EmptyState';
import InstructionVisibilityContext from './InstructionVisibilityContext';
import FullScreenHeader from './FullScreenHeader';
import useFullScreenWorkout from './useFullScreenWorkout';

const FullScreenWorkoutView = ({ match }) => {
    const { session, isLoading, hasError } = useFullScreenWorkout(
        match.params.programWorkoutId
    );

    return (
        <InstructionVisibilityContext.Provider value={!isLoading}>
            <div className="fullscreen-workout">
                <FullScreenHeader session={session} />
                <div
                    className={
                        isLoading
                            ? 'fullscreen-workout-content loading'
                            : hasError
                                ? 'fullscreen-workout-content empty'
                                : 'fullscreen-workout-content'
                    }
                >
                    {isLoading ? (
                        <CircularProgress height={48} width={48} />
                    ) : hasError ? (
                        <EmptyState
                            icon={
                                <ErrorOutlineIcon
                                    style={{
                                        fontSize: 48,
                                        marginBottom: 8
                                    }}
                                />
                            }
                            title="Something went wrong"
                            text="We couldn't load this workout."
                        />
                    ) : (
                        <Session session={session} isPreview={true} />
                    )}
                </div>
            </div>
        </InstructionVisibilityContext.Provider>
    );
};

export default FullScreenWorkoutView;



// WEBPACK FOOTER //
// ./src/view/fullScreenWorkout/FullScreenWorkoutView.jsx